// extracted by mini-css-extract-plugin
export default {"container":"PassengerItemGroup_container__iewn9","passenger":"PassengerItemGroup_passenger__PRuFf"};